import { render } from "./hkcmaPage.vue?vue&type=template&id=55699405&scoped=true&ts=true"
import script from "./hkcmaPage.vue?vue&type=script&lang=ts"
export * from "./hkcmaPage.vue?vue&type=script&lang=ts"

import "./hkcmaPage.vue?vue&type=style&index=0&id=55699405&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55699405"]])

export default __exports__